export default {
    general: {
        cancel:  'Cancel',
        confirm: 'Confirm',
        loading: 'Loading …',
        retry:   'Try again',
        copy:    'Copy',
        copied:  'Copied',
    },
    brand: {
        product_name: 'Rezervacije',
    },
    layout: {
        switch_language: 'Preklopi v slovenščino',
        footer:          'Rezervacije — online booking',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    errors: {
        generic_error:      'An error occurred',
        try_again:          'Please try again in a moment.',
        invalid_data:       'The details are not valid. Please check them and try again.',
        not_found:          'Not found',
        slot_unavailable:   'This time has just been taken. Please choose another.',
        incorrect_status:   'The booking is already cancelled or completed.',
        cancel_not_allowed: 'It is too late to cancel online. Please call us.',
    },
    validation: {
        required: 'This field is required',
        email:    'Enter a valid email address',
    },
    not_found: {
        title:                'Page not found',
        description:          'Please check the address you were given.',
        business_title:       'Booking is not available',
        business_description: 'This page does not exist or online booking is currently switched off.',
    },
    landing: {
        book:        'Book',
        no_services: 'There are no services to book online at the moment.',
    },
    service: {
        back:           'All services',
        not_found:      'This service can no longer be booked.',
        step_day:       '1. Choose a day',
        step_time:      '2. Choose a time',
        step_details:   '3. Your details',
        no_days_month:  'No free times this month — have a look at the next one.',
        no_times:       'No free times left on this day.',
        name:           'Full name',
        email:          'Email',
        email_help:     'We send the confirmation and a cancellation link here.',
        phone:          'Phone',
        notes:          'Message (optional)',
        marketing_consent: 'I would like to receive news and offers from {name} by e-mail. I can withdraw my consent at any time.',
        confirm:        'Confirm booking',
        no_payment:     'No online payment is needed.',
    },
    booking: {
        status: {
            booked:    'Confirmed',
            completed: 'Completed',
            cancelled: 'Cancelled',
            no_show:   'No-show',
        },
    },
    manage: {
        booking:                'Booking',
        booked_title:           'Your booking is confirmed',
        booked_description:     'Keep the link below — with it you can view or cancel the booking at any time.',
        service:                'Service',
        when:                   'Time',
        name:                   'Name',
        price:                  'Price',
        pay_on_site:            'pay on site',
        keep_link:              'Your booking link:',
        book_another:           'New booking',
        cancel:                 'Cancel booking',
        cancel_confirm:         'Cancel this booking? The time will be released for others.',
        cancelled:              'The booking is cancelled',
        cannot_cancel:          'It is too late to cancel online — please call us.',
        not_found:              'Booking not found',
        not_found_description:  'The link is incomplete or wrong. Please use the link from your confirmation.',
    },
    access: {
        title: 'Entry code',
        valid: 'The code opens the gate from {from} to {until}.',
        valid_same_day: 'The code opens the gate on {day} from {from} to {until}.',
    },
}
